const ApplicationName = 'Channel Care';
const ApplicationNamePlannedMaintenance = 'Planned Maintenance';
const ApplicationNameIncidents = 'Incident Management';
const ApplicationNameQuotes = 'IPS';
const platformAppName = 'Platform';
const serviceRequestAppName = 'Request Management';
const ApplicationNameOneFund = 'One Fund';
const ApplicationNameConnectedSuppluChain = 'CSC Tracking';
const ApplicationNameSelfServiceMigration = 'Self-Service Migration';
const ApplicationNameUnifiedTracking = 'Tracking';
const ApplicationNameOpsHub = 'Ops Hub';

const Links = Object.freeze({
    viewCases: '/tracking/enquiries support enquiry',
    viewOrdersList: '/unified-tracking/orders',
    newCase: 'Submit support Enquiry',
    submitEnquiry: 'Submit New Enquiry',
    retryEnquiry: 'Retry New Enquiry',
    newCaseErrorScreen: 'New Enquiry Error Screen',
    newCaseSuccessScreen: 'New Enquiry Success Screen',
    dashboard: 'Go to Dashboard',
    caseDetails: 'Enquiry Details',
    enquiryNumber: (enquiryID: string) => `EnquiryNumber ${enquiryID}`,
    helpNowButton: 'Clicked on Get help now button',
    hideCovid19BannerButton: 'Clicked on Hide button',
    viewIncidentTickets: 'Open Incident Tickets',
    newIncidentTickets: 'Create New Incident Tickets',
    viewRequestTickets: 'View Your products & services',
    newRequestTickets: 'Create New Request',
    tryAgain: 'Try Again',
    reportError: 'Report an Error',
    pageChange: 'Page changed',
    pageSizeChange: 'Page size changed',
    faq: 'Clicked on frequently asked questions',
    downloadSuccess: 'Download successfull',
    downloadFailure: 'Download failed',
    visitTWHUB: 'Clicked on TWHUB Link',
    visitServiceTool: 'Clicked on Service Tool Link',
    visitSevOne: 'Clicked on SevOne Link',
    supportFaq: 'FAQ Page View',
    attachmentTypeClickedToDownload: (attachType: string) => `Clicked to download ${attachType}`,
    sortChange: (column: string, order: string) => `${column} ${order} Sorting `,
    companyDropdown: (companyName: string) => `Selected ${companyName} Company`,
});

const Components = Object.freeze({
    casesListComponent: 'Tracking-Enquiries',
    newCaseComponent: 'New Enquiry',
    newCaseSuccessComponent: 'New Enquiry Success',
    newCaseErrorComponent: 'New Enquiry Error',
    dashBoardComponent: 'Dashboard',
    caseDetailsComponent: 'Enquiry Details',
    caseDetailsErrorComponent: 'Enquiry Details Error',
    helpNowButtonComponent: 'Clicked on Get help now button',
    hideCovid19BannerButtonComponent: 'Clicked on Hide button',
    essentialServicesPageComponent: 'Essential services page',
    caseCreateComponent: 'Case Create Form',
    customerSupportLandingPage: 'Help and support landing page',
    downloadAttachmentDomestic: 'Clicked on download domestic attachment'
});

const Button = Object.freeze({
    Filter: 'Filter opened',
    ApplyFilter: 'Filter Apply',
    EditFilter: 'Filter Edit',
    UpdateFilter: 'Filter Update',
    ClearAllFilter: 'Filter Clear all',
    CancelFilter: 'Filter Cancel',
    SearchCaseBtn: 'Search table button in tracking enquiry',
    ClearSearchBtn: 'Clear search button in tracking enquiry',
    SubmitIncident: 'Submit an incident',
    SubmitRequest: 'Submit a service request',
    SubmitIncidentFromDropdownClick: 'Submit an incident after selecting option from dropdown',
    SubmitRequestFromDropdownClick: 'Submit a service request after selecting option from dropdown',
    AddComment: 'Add comment on enquiry details page',
    AddCommentSuccess: 'Add comment on enquiry details page is successful',
    AddCommentFailure: 'Add comment on enquiry details page failed',
    BackButtonYes: 'yes, leave this page',
    BackButtonNo: 'no, stay on this page',
    ModalOpen: 'Back button Modal Open',
    trackOpenEnquiries: 'Track open support enquiries button clicked',
    next: 'Next button clicked',
    back: 'Back button clicked',
    submit: 'Submit button clicked',
});

export {
    ApplicationName,
    ApplicationNamePlannedMaintenance,
    ApplicationNameIncidents,
    ApplicationNameQuotes,
    platformAppName,
    serviceRequestAppName,
    ApplicationNameOneFund,
    ApplicationNameConnectedSuppluChain,
    ApplicationNameSelfServiceMigration,
    ApplicationNameUnifiedTracking,
    ApplicationNameOpsHub,
    Links,
    Components,
    Button
};
